<template>
  <div>
    <v-divider class="pb-4" />
    <p class="font-weight-bold">
      Vendedor solicitou
      <span class="text-uppercase">
        devolução
      </span>
      do produto
    </p>
    <p v-if="codigoPostagem">
      <strong>Código para postagem</strong> {{ codigoPostagem }}
    </p>
    <v-btn
      class="d-block mx-auto"
      color="primary"
      data-cy="btn_informar_devolucao"
      max-width="288"
      width="100%"
      @click="$router.push('/devolucao-produto')"
    >
      Informar devolução
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'CardDevolucaoProduto',

  props: {
    codigoPostagem: {
      type: String,
      default: '',
    },

  },
};
</script>
